module.exports = __webpack_public_path__ + "files/96b926b901de91cc102721b0a1383a5d.png";